import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    data() {
        return {
            gruppiItems: [],
            pathResourceBase: "/saccsarr",
            pathResourcePresaInCarico: "/saccsarr/presaincarico",
            saccSarrItems: {},
            blankJson: {
                "id": "",
                "code": "",
                "processId": "",
                "patient": {
                    "id": "",
                    "name": "",
                    "code": ""
                },
                "patientAnonymous": false,
                "patientStrangerGuest": false,
                "supplyModeCategory": {
                    "id": 0,
                    "name": "",
                    "code": ""
                },
                "prescription": {
                    "patient": {
                        "id": "",
                        "firstName": "",
                        "lastName": "",
                        "type": 0,
                        "name": ""
                    },
                    "nre": "",
                    "compilationDatetime": "",
                    "doctor": {
                        "id": "",
                        "name": ""
                    },
                    "doctorType": {
                        "id": ""
                    },
                    "exemption": {
                        "id": "",
                        "name": "",
                        "computationMode": {
                            "id": 0,
                            "name": ""
                        }
                    },
                    "priorityClass": {
                        "id": ""
                    },
                    "prescriptionType": {
                        "id": "",
                        "name": ""
                    },
                    "compliationType": {
                        "id": "",
                        "name": "",
                        "code": ""
                    },
                    "moduleType": {
                        "id": ""
                    },
                    "entryDatetime": "",
                    "payed": false,
                    "hasSymptoms": "",
                    "noContact": false
                },
                "type": {
                    "id": "",
                    "name": "",
                    "exameResultEnabled": false,
                    "isPac": false
                },
                "origin": {
                    "id": "",
                    "name": "",
                    "code": ""
                },
                "directEntry": false,
                "cover": {
                    "id": "",
                    "name": ""
                },
                "organization": {
                    "id": ""
                },
                "authority": {
                    "id": "",
                    "name": "",
                    "code": ""
                },
                "hospital": {
                    "id": "",
                    "name": ""
                },
                "site": {
                    "id": "",
                    "name": ""
                },
                "totalAmount": 0.0,
                "personBilledAmount": 0.0,
                "personCashedAmount": 0.0,
                "details": [
                    {
                        "id": 0,
                        "service": {
                            "id": "",
                            "code": "",
                            "name": "",
                            "startDate": "",
                            "endDate": "",
                            "weight": 0.0,
                            "groupId": ""
                        },
                        "specialization": {
                            "id": "",
                            "name": ""
                        },
                        "requiresSpecificConsent": false,
                        "price": 0.0,
                        "variablePrice": "",
                        "quantity": 0,
                        "booking": {
                            "id": "",
                            "code": "",
                            "startTime": "",
                            "endTime": "",
                            "diary": {
                                "id": ""
                            },
                            "registrationUser": {
                                "id": "",
                                "name": ""
                            }
                        },
                        "executionUnit": {
                            "id": "",
                            "name": ""
                        },
                        "scheduledDatetime": "",
                        "executionDatetime": "",
                        "status": {
                            "id": "",
                            "name": ""
                        },
                        "enable": "",
                        "statusReason": {
                            "id": "",
                            "name": ""
                        },
                        "phoneNumber": "",
                        "site": {
                            "id": "",
                            "name": "",
                            "address": ""
                        },
                        "hospital": {
                            "id": "",
                            "name": ""
                        },
                        "authority": {
                            "id": "",
                            "name": "",
                            "code": ""
                        }
                    }
                ],
                "admissionDate": "",
                "iuvCode": "",
                "noticeNumber": "",
                "preDocuments": [
                    {
                        "id": "",
                        "amount": 0.0,
                        "stampDuty": 0.0,
                        "type": {
                            "id": ""
                        }
                    }
                ],
                "cashStatus": {
                    "id": "",
                    "name": ""
                },
                "status": {
                    "id": "",
                    "name": ""
                },
                "iuvPaymentStatus": ""
            }
        };
    },
    methods: {
        loadDataByNre(codiceStruttura, nre, callbackSuccess = null, callBackError = null) {
            let filter = {
                nre: nre
            }
            this.saccSarrItems = {}
            let methodCallBack = this.loadDataByNreSuccess;
            if (callbackSuccess) {
                methodCallBack = callbackSuccess;
            }
            let methodCallBackError = this.loadDataByNreErrr;
            if (callBackError) {
                methodCallBackError = callBackError;
            }
            this.loadDataResources(this.pathResourcePresaInCarico + "/" + codiceStruttura, filter, methodCallBack, methodCallBackError);
        },
        loadDataByNreSuccess(response) {
            this.saccSarrItems = response.data.data;
            this.closeShowModalLoading();

        },
        loadDataByNreErrr(err) {
            console.log(err);
            this.closeShowModalLoading();
        }
    },
};